<template>
  <div class="chip-status">
    <v-chip
      :color="getStatus.color"
      :text-color="getStatus.textColor"
      class="text-uppercase"
      label
      :disabled="disabled"
    >
      {{ getStatus.label || undefinedStatusLabel }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'ChipStatus',
  props: {
    status: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      avaibleStatus: {
        ATIVO: {
          color: '#EAFAF5',
          textColor: 'success',
          label: this.$t('support.components.chips.status.active'),
        },
        INATIVO: {
          color: '#FAEAEB',
          textColor: '#8C8282',
          label: this.$t('support.components.chips.status.inactive'),
        },
        PENDENTE: {
          color: '#FAF6EA',
          textColor: 'warning',
          label: this.$t('support.components.chips.status.underReview'),
        },
        BLOQUEADO: {
          color: '#FAEAEB',
          textColor: 'error',
          label: this.$t('support.components.chips.status.blocked'),
        },
        ABERTA: {
          color: '#FCF5D4',
          textColor: '#F2905E',
          label: this.$t('support.components.chips.status.open'),
        },
        VENCIDA: {
          color: '#FAEAEB',
          textColor: '#8C8282',
          label: this.$t('support.components.chips.status.expired'),
        },
        DEFAULT: {
          color: '#EAFAF5',
          textColor: 'success',
        },
        UNDEFINED: {
          color: '#FAEAEB',
          textColor: '#8C8282',
          label: 'Status Inválido',
        },
      },
    };
  },
  computed: {
    getStatus() {
      if (!this.undefinedStatusLabel || !this.status) {
        return this.avaibleStatus.UNDEFINED;
      }
      return this.avaibleStatus[this.status] || this.avaibleStatus.DEFAULT;
    },
    undefinedStatusLabel() {
      return this.status.replace('_', ' ');
    },
  },
};
</script>

<style lang="stylus">
  .chip-status
    .v-chip
      min-width 100px
      border-radius 4px !important
    .v-chip--label
      .v-chip__content
        margin 0 auto
        font-weight bold !important
</style>
